import styled from 'styled-components';
import cssKit from '../../css';

export const StyledLeafDisclaimer = styled.div`
  position: relative;
  top: 20px;
  text-transform: none;
  font-size: .7rem;
  font-family: arial,helvetica,verdana,sans-serif;
  font-weight: 400;
  height: auto;
  color: #558fe6;

  ${cssKit.media.greaterThan('small') `
    height: 80px;
    top: 0px;
  `};

  ${cssKit.media.greaterThan('medium') `
    height: 55px;
    top: 20px;
  `};

  @media screen and (min-width: 800px) {
    height: 50px
  }
`;



/** WEBPACK FOOTER **
 ** ./src/components/LeafDisclaimer/styles.js
 **/